const key="g3ai-selected-authorized-tenant";
export function rememberTenant(id:string){localStorage.setItem(key,id);}
// A hint for navigation only. Backend authorization remains mandatory.
export function preferredTenant<T extends {id:string}>(tenants:T[],requested?:string|null):T|undefined{
 const id=requested??localStorage.getItem(key);
 return tenants.find(t=>t.id===id)??tenants[0];
}
